<template>
	<div >
		<div class="app-container">
			<el-descriptions title="特种设备基本信息" :column="2" border>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
					设备种类
					</template>
					  {{tzsbjbxx.equipclass}}
				</el-descriptions-item>				
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	设备品种
				 	</template>
				 	  {{tzsbjbxx.equipbreeds}}
				</el-descriptions-item>	
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	制造单位
				 	</template>
				 	  {{tzsbjbxx.createorg}}
				</el-descriptions-item>	
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	设备类别
				 	</template>
				 	  {{tzsbjbxx.equipcategory}}
				</el-descriptions-item>	
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	型号（规格）
				 	</template>
				 	  {{tzsbjbxx.specs}}
				</el-descriptions-item>	
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	设计单位
				 	</template>
				 	  {{tzsbjbxx.designorg}}
				</el-descriptions-item>	
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	使用单位
				 	</template>
				 	  {{tzsbjbxx.useorg}}
				</el-descriptions-item>	
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	使用单位地址
				 	</template>
				 	  {{tzsbjbxx.useadress}}
				</el-descriptions-item>	
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	安全管理人员
				 	</template>
				 	  {{tzsbjbxx.securitymangeperson}}
				</el-descriptions-item>	
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	安全管理人员移动电话
				 	</template>
				 	  {{tzsbjbxx.useorgmobile}}
				</el-descriptions-item>	
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	产权单位
				 	</template>
				 	  {{tzsbjbxx.propertyorg}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	设备使用地点
				 	</template>
				 	  {{tzsbjbxx.equipuseadress}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	使用单位电话
				 	</template>
				 	  {{tzsbjbxx.useorgtel}}  
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	检验机构名称
				 	</template>
				 	  {{tzsbjbxx.checkorg}}  
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	检验日期
				 	</template>
				 	  {{tzsbjbxx.checkdate}}  
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	下次检验日期
				 	</template>
				 	  {{tzsbjbxx.nextcheckdate}}  
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	检验报告编号
				 	</template>
				 	  {{tzsbjbxx.checkreportno}}  
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:120px">
				 	<template slot="label" >						 
				 	检验结论
				 	</template>
				 	  {{tzsbjbxx.checkresult}}  
				</el-descriptions-item>
			</el-descriptions>
			 
		</div>
	</div>
</template>

<script> 
	export default {
		name: 'TzsbJbxx',
		props: {
			//特种设备基本信息
			tzsbjbxx: {
				type: Object,
				require: true
			}
		},
		watch: {
			tzsbjbxx(newValue, oldValue) {
				//this.init();
			},
			immediate: true,
			deep: true,
		},
		data() {
			return {
				 
			}
		},
		created() {
			//this.init();
			 
		},
		methods: {
			 
		}
	}
</script>

<style scoped>
	/deep/ .el-descriptions__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0px;
	}

	.el-title {
		box-sizing: border-box;
		font-size: 16px;
		font-weight: 700;
		color: #303133;
		padding-top: 10px;
		text-align: left;
	}
</style>
